import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
}), 'CallMergeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMergeSharp.js
// module id = 2602
// module chunks = 2